import { useRef, useState, useEffect } from "react";
import { Handle, Position } from "reactflow";
import { PicCenterOutlined } from "@ant-design/icons";

import { ButtonDelete } from "../ButtonDelete";
import autoResizeTextarea from "utils/autoResizeTextarea";
import { useFlowNodes } from "../../context";

import "./DescriptionNode.scss";

const DescriptionNode = ({ id }) => {
  const { t, intent, updateIntent, setNodes, setEdges } = useFlowNodes();

  const inputRef = useRef();
  const [description, setDescription] = useState(
    () => intent?.description || ""
  );

  useEffect(() => {
    setDescription(intent?.description || "");
  }, [intent?.description]);

  useEffect(() => {
    if (inputRef.current) {
      autoResizeTextarea(inputRef.current);
    }
  }, [description]);

  const handleChange = (e) => {
    setDescription(e.target.value);
  };

  const handleBlur = () => {
    updateIntent?.((prev) => ({
      ...prev,
      description,
    }));
  };

  const handleDelete = () => {
    setDescription("");
    updateIntent?.((prev) => ({
      ...prev,
      description: "",
    }));
  };

  return (
    <>
      <Handle
        type="target"
        position={Position.Bottom}
        id="main"
        className="handle-descripcion"
      />

      <div className="description-root">
        <div className="description-header">
          <span className="icon-root-badge">
            <PicCenterOutlined />
          </span>

          <span className="description-title">
            {t("common:intents.descript.title")}
          </span>

          <ButtonDelete
            setNodes={setNodes}
            setEdges={setEdges}
            nodeId={id}
            onClick={handleDelete}
            position={Position.Top}
            handleDelete={handleDelete}
          />
        </div>

        <div className="intent-separator" />

        <div className="description-container">
          <textarea
            ref={inputRef}
            value={description}
            onChange={handleChange}
            onBlur={handleBlur}
            className="description-textarea"
            placeholder={t("common:intents.descript.placeholder")}
            aria-label={t("common:intents.descript.title")}
            rows={3}
          />
        </div>
      </div>
    </>
  );
};

export default DescriptionNode;
